export default __webpack_public_path__ + "static/media/image_demo_in_person_visit.076f33cc.svg";